import { AxiosError } from 'axios';
import {
  GET_GROUP_EXAM_REGISTRATION_RECEIPT_DETAILS,
} from "../../constants/apiUrls";
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {
  GET_GROUP_EXAM_REGISTRATION_RECEIPT_DETAILS_QUERY_KEY,
} from "../../constants/queryKeys";
import { GenericErrorResponse } from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface GroupExamRegistrationReceiptDetailsResponse {
  applicationId: string;
  paymentDateTime: string;
}


// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: GroupExamRegistrationReceiptDetailsResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const useGetGroupExamRegistrationReceiptDetails = ({
  uuid,
  onSuccess,
  onError,
}: Input) => {
  const getGroupExamRegistrationReceiptDetails = async () => {
    const res = await axiosClient.get<GroupExamRegistrationReceiptDetailsResponse>(
      GET_GROUP_EXAM_REGISTRATION_RECEIPT_DETAILS(uuid)
    );
    return res.data;
  };
  return useCustomQuery(
    [GET_GROUP_EXAM_REGISTRATION_RECEIPT_DETAILS_QUERY_KEY],
    getGroupExamRegistrationReceiptDetails,
    {
      onSuccess,
      onError,
    },
  );
};
